import React from 'react';

export default function ToggleCurrency({ children }) {
  return <div className="d-flex align-items-center">{children}</div>;
}
